export function formatNumber(n, dec = 2) {
    if (n == null || isNaN(n)) return "—";
    const abs = Math.abs(n);
    if (abs >= 1_000_000_000) return (n / 1_000_000_000).toFixed(2) + "B";
    if (abs >= 1_000_000) return (n / 1_000_000).toFixed(2) + "M";
    if (abs >= 1_000) return (n / 1_000).toFixed(2) + "K";
    return n.toFixed(dec);
}

export function formatUSD(n, dec = 2) {
    if (n == null || isNaN(n)) return "—";
    return "$" + Number(n).toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec });
}

export function formatPrice(n) {
    if (n == null || isNaN(n)) return "—";
    const abs = Math.abs(n);
    if (abs >= 1000) return n.toFixed(2);
    if (abs >= 1) return n.toFixed(4);
    if (abs >= 0.01) return n.toFixed(5);
    return n.toFixed(6);
}

export function formatPct(n, dec = 2) {
    if (n == null || isNaN(n)) return "—";
    const sign = n > 0 ? "+" : "";
    return `${sign}${n.toFixed(dec)}%`;
}

export function shortAddr(a) {
    if (!a) return "—";
    return `${a.slice(0, 6)}…${a.slice(-4)}`;
}

export function timeLeft(unixSec) {
    const now = Date.now() / 1000;
    let s = Math.max(0, unixSec - now);
    const d = Math.floor(s / 86400); s -= d * 86400;
    const h = Math.floor(s / 3600); s -= h * 3600;
    const m = Math.floor(s / 60); s -= m * 60;
    const sec = Math.floor(s);
    if (d > 0) return `${d}d ${h}h ${m}m`;
    if (h > 0) return `${h}h ${m}m ${sec}s`;
    if (m > 0) return `${m}m ${sec}s`;
    return `${sec}s`;
}

export const DURATION_OPTIONS = [
    { key: "15m", label: "15 minutes" },
    { key: "30m", label: "30 minutes" },
    { key: "1h", label: "1 hour" },
    { key: "3h", label: "3 hours" },
    { key: "6h", label: "6 hours" },
    { key: "12h", label: "12 hours" },
    { key: "24h", label: "24 hours" },
    { key: "15d", label: "15 days" },
    { key: "1mo", label: "1 month" },
    { key: "1yr", label: "1 year" },
];

export const ENTRY_FEE_PCT = {
    "15m": 0.00025,
    "30m": 0.0005,
    "1h":  0.0010,
    "3h":  0.0015, "6h":  0.0015, "12h": 0.0015, "24h": 0.0015,
    "15d": 0.0020,
    "1mo": 0.0035,
    "1yr": 0.0050,
};

export function entryFee(notional, durationKey) {
    const pct = ENTRY_FEE_PCT[durationKey] ?? 0.001;
    return (parseFloat(notional) || 0) * pct;
}

export function entryFeePctLabel(durationKey) {
    const pct = ENTRY_FEE_PCT[durationKey] ?? 0.001;
    const v = pct * 100;
    return v < 0.1 ? `${v.toFixed(3)}%` : `${v.toFixed(2)}%`;
}
